import React, { useState } from 'react';
import studentGroups from '../../cms/studentgroups.json';
import pageIntros from '../../cms/page-intros.json';
import PageChrome from '../../components/layout/PageChrome';
import StudentGroupCard from '../../components/cards/StudentGroupCard';
import RichText from '../../components/ui/RichText';
import { FaEnvelope } from 'react-icons/fa';
import '../../css/student-life/StudentGroups.css';

const intro = pageIntros.studentGroups || {};

const StudentGroups = () => {
  const [selectedGroup, setSelectedGroup] = useState(null);

  const closeModal = () => {
    setSelectedGroup(null);
  };

  return (
    <>
      <PageChrome
        title={intro.title}
        subtitle={intro.subtitle}
        intro={intro.intro}
      >
        <section className="student-groups-page-section">
          <div className="student-groups-page-grid">
            {studentGroups.map((group) => (
              <div 
                key={group.id}
                className="student-groups-page-card-wrapper"
              >
                <StudentGroupCard 
                  group={group}
                  onClick={() => setSelectedGroup(group)}
                />
              </div>
            ))}
          </div>
        </section>
      </PageChrome>

      {/* Student Group Modal */}
      {selectedGroup && (
        <div className="student-group-modal-overlay" onClick={closeModal}>
          <div className="student-group-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="student-group-modal-close" onClick={closeModal}>×</button>
            <div className="student-group-modal-header">
              <h2 className="student-group-modal-name">{selectedGroup.name}</h2>
              <div className="student-group-modal-contact">
                <FaEnvelope className="student-group-modal-email-icon" />
                <a 
                  href={`mailto:${selectedGroup.contact.email}`}
                  className="student-group-modal-contact-link"
                >
                  {selectedGroup.contact.name}
                </a>
              </div>
            </div>
            <div className="student-group-modal-body">
              <RichText value={selectedGroup.description} className="student-group-modal-description" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StudentGroups; 